<script setup lang="ts"></script>

<template>
  <div class="ellipsis-menu">
    <app-dropdown>
      <div class="size-8 flex-center text-xl">
        <fa-icon icon="i-far-ellipsis-vertical" />
      </div>

      <template #items>
        <slot></slot>
      </template>
    </app-dropdown>
  </div>
</template>
